import { render } from "./Jozzy.vue?vue&type=template&id=70450d6e&scoped=true"
import script from "./Jozzy.vue?vue&type=script&lang=js"
export * from "./Jozzy.vue?vue&type=script&lang=js"

import "./Jozzy.vue?vue&type=style&index=0&id=70450d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70450d6e"]])

export default __exports__